import { API_CALL_FAILED, API_CALL_SUCCESS } from '../actions/actionTypes';

const initialState = () => ({
  warningFailure: false,
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case API_CALL_FAILED: {
      return Object.assign(
        {},
        {
          warningFailure: true,
          msg: action.msg,
        },
      );
    }
    case API_CALL_SUCCESS: {
      return Object.assign(
        {},
        {
          warningFailure: false,
          msg: action.msg,
        },
      );
    }
    default:
      return state;
  }
};

export default reducer;
